<template>
  <svg
    id="Check-Badge--Streamline-Nova"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Check Badge Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M11.2929 0.292893c0.3905 -0.3905241 1.0237 -0.3905241 1.4142 0L15.6362 3.222h4.1418c0.5523 0 1 0.44772 1 1v4.14179l2.9291 2.92911c0.3905 0.3905 0.3905 1.0237 0 1.4142l-2.9291 2.9291v4.1418c0 0.5523 -0.4477 1 -1 1h-4.1418l-2.9291 2.9291c-0.3905 0.3905 -1.0237 0.3905 -1.4142 0L8.36379 20.778H4.222c-0.55228 0 -1 -0.4477 -1 -1v-4.1418L0.292893 12.7071c-0.3905241 -0.3905 -0.3905241 -1.0237 0 -1.4142L3.222 8.36379V4.222c0 -0.55228 0.44772 -1 1 -1h4.14179L11.2929 0.292893Zm0.7678 15.267807 5.5 -5.5 -2.1214 -2.12136L11 12.3787 8.56066 9.93934 6.43934 12.0607l3.5 3.5c0.58576 0.5857 1.53556 0.5857 2.12136 0Z"
      clip-rule="evenodd"
      stroke-width="1"
    ></path>
  </svg>
</template>
